<!--Searchbar-->
<div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <form [formGroup]="searchFilterForm" class="d-flex mb-3 px-1">
            <input formControlName="searchFilterField" class="form-control bar" type="search" placeholder="Cerca..."
                aria-label="Search">
            <button type="submit" class="bordersearch" (click)="clickSearch()"><i
                    class="far fa-search grey"></i></button>
        </form>
    </div>
</div>



<!-- Filters -->
<div class="row">
    <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12">
        <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 p-1 inlineflex-md">
            <angular2-multiselect *ngIf="menuList" [data]="menuList" [(ngModel)]="selectedMenu"
                [settings]="menuSettings" [ngModelOptions]="{standalone: true}" (onSelect)="changeLengthPage($event)"
                (onDeSelect)="removeLength()" (onDeSelectAll)="removeLength()">
            </angular2-multiselect>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 p-1 inlineflex-md">
            <angular2-multiselect *ngIf="dealerCategoryList" [data]="dealerCategoryList"
                [(ngModel)]="searchFilterOther.searchFilterField_dealerCategory" [settings]="dealerCategorySettings"
                [ngModelOptions]="{standalone: true}" (onSelect)="changeFilter()" (onDeSelect)="changeFilter()"
                (onSelectAll)="changeFilter()" (onDeSelectAll)="changeFilter()">
            </angular2-multiselect>
        </div>

        <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12 p-1 inlineflex-md">
            <ng-autocomplete #productAndServices placeholder="Cerca Prodotti e servizi"
                [data]="productAndServices_Suggestion" [searchKeyword]="productAndServices_Keyword"
                (selected)='selectEvent__productAndServices($event)' (inputChanged)='getList_productAndServices($event)'
                (inputFocused)='onFocused__productAndServices($event)'
                (inputCleared)="searchCleared__productAndServices()" [itemTemplate]="itemTemplate_productAndServices"
                [notFoundTemplate]="notFoundTemplate_productAndServices" [debounceTime]="600"
                [isLoading]="productAndServices_isKeywordLoadingResult" [minQueryLength]="2">
            </ng-autocomplete>
            <ng-template #itemTemplate_productAndServices let-item>
                <div class="col-12">
                    <div class="mx-3">
                        <span [innerHTML]="item.serviceName"></span>
                    </div>
                </div>
            </ng-template>
            <ng-template #notFoundTemplate_productAndServices let-notFound>
                {{errorMsg_productAndServices}}
            </ng-template>
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 py-1">
            <div class="mx-3">
                <fieldset class="fieldset-fw" [hidden]="productAndServices_Selected.length === 0">
                    <legend hidden></legend>
                    <app-draggable-list-chip [itemList]="productAndServices_Selected"
                        [labelKeys]="labelKeys_productAndServices" [draggable]="false"
                        (changeItemList)="onChangeItemList_productAndServices($event)">
                    </app-draggable-list-chip>
                </fieldset>
            </div>
        </div>
    </div>


    <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 text fw-normal size16 txt-remove">
        <span class="clickable" (click)="clickButtonClearFilter()"> Rimuovi filtri</span>
    </div>

</div>



<!-- Riga selezioni -->
<div class="row mt-4 my-2" *ngIf="!isEmpty">
    <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 text fw-normal size15">
        {{totalChecked}} elementi selezionati
    </div>
    <div class="col-lg-6 col-md-8 col-sm-8 col-xs-12 text fw-normal size15">
        <app-mass-modify [massModifyItems]="massModifyItems"
            (choiceButtonMassModify)="choiceButtonMassModifyResponse($event)"></app-mass-modify>
        <app-mass-modify [title]="titleFlag" [massModifyItems]="massModifyItemsFlags" class="mx-3"
            (choiceButtonMassModify)="choiceButtonMassModifyResponse($event)"></app-mass-modify>
        <span class="txt-remove" (click)="onExportXML()">
            Exporta CSV
        </span>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 text fw-normal size15 txt-remove last-text">
        <span (click)="onCancelSelected()">
            Annulla selezione
        </span>
    </div>
</div>



<!-- Table -->
<div class="w-100" [ngClass]="!isEmpty  ? 'table-responsive-sm blocks': 'not_visible'">
    <table aria-describedby=""  datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped" style="width: 100%;">
        <thead>
            <tr class="back-white fw-bold">
                <th class="text-center pb-4 border-bottom-0" scope="col">
                    <input class="form-check-input checkboxes" type="checkbox" value="" id="check_all"
                        [checked]="statusCheckAll" (change)="onCheckAll()">
                </th>
                <th class="pb-4 border-bottom-0" scope="col">Data di creazione</th>
                <th class="pb-4 border-bottom-0" scope="col">Codice COMSY</th>
                <th class="pb-4 border-bottom-0" scope="col">Nome store</th>
                <th class="pb-4 border-bottom-0" scope="col">Indirizzo</th>
                <th class="pb-4 border-bottom-0" scope="col">Città</th>
                <th class="pb-4 border-bottom-0" scope="col">Categoria dealer</th>
                <th class="pb-4 border-bottom-0" scope="col">Pubblicato</th>
                <th class="pb-4 border-bottom-0" scope="col"></th>
            </tr>
        </thead>
        <tbody [hidden]="isSearching">
            <tr class="table-font" *ngFor="let obj of entityList">
                <td class="text-center">
                    <input class="form-check-input checkboxes" type="checkbox" value="" id="check_{{obj.id}}"
                        [checked]="obj.checked" (change)="onCheckRow(obj.id)">
                </td>
                <td>{{obj.createdAt | date: 'dd/MM/yyyy'}}</td>
                <td>{{obj.title}}</td>
                <td>{{obj.dealerDescription}}</td>
                <td>{{obj.location.normalizedAddress}}</td>
                <td>{{obj.location.normalizedCity}}</td>
                <td>{{obj.dealerCategory}}</td>
                <td>
                    <i [hidden]="!obj.published" class="fas fa-circle grn"></i>
                    <i [hidden]="obj.published" class="fas fa-circle red"></i>
                </td>
                <td>
                    <div class="flex">
                        <a rel="noopener" title="Visualizza pagina" class="btn btn-lg pr-0" href="{{fe_url}}it/{{obj.seoId}}/" target="_blank"
                            [hidden]="!obj.published">
                            <i class="fas fa-external-link-alt blu"></i>
                            </a>
                        <a title="Visualizza pagina" class="btn btn-lg pr-0 disabled" href="javascript:void(0);"
                            [hidden]="obj.published">
                            <i class="fas fa-external-link-alt"></i>
                            </a>
                        <a class="pr-5 btn btn-lg" (click)="clickButtonUpdate(obj.id)"><i class="far fa-pencil ora"></i></a>
                    </div>
                </td>
            </tr>
        </tbody>
        <tfoot [hidden]="!isSearching">
            <tr>
                <td colspan="9">
                    <app-spinner-table [visible]="isSearching"></app-spinner-table>                 
                </td>
            </tr>
        </tfoot>
    </table>
</div>
<div *ngIf="isEmpty" class="table-responsive-sm blocks no-data w-100">
    <div class="result-message">
        <span class="message-font">La ricerca non ha prodotto risultati!</span>
    </div>
</div>